import { expand } from 'uri-template-lite';

import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { InputDataUrl } from './InputDataUrl';
import { InputDataDetailsKey } from '../schema/types';

const postInputDataLock = (params: InputDataDetailsKey & { lock: boolean }) =>
  apiClient
    .post(
      expand(InputDataUrl.INPUT_DATA_LOCK, {
        ...params,
        action: params.lock ? 'lock' : 'unlock',
      })
    )
    .then((response) => response.data);

export const useMutateInputDataLock = createApiMutationHook(
  ['inputDataLock'],
  getMutationFn(postInputDataLock)
);
